package com.wintermar.inspection.core.ui.component.snackbar.util

import androidx.compose.ui.graphics.Color
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_alert
import org.jetbrains.compose.resources.DrawableResource

data class SnackBarVariantModel(
    val backgroundColor: Color,
    val iconColor: Color,
    val borderColor: Color,
    val icon: DrawableResource = Res.drawable.ic_alert,
)
